module.exports = __webpack_public_path__ + "static/img/gytp.cf096346.png";